import { useGetConfig } from "@/api/generated/config/config"
import { STALE } from "@/api/query-client"
import { useMe } from "./session"

/**
 * `GET /config` (LLD §6.4): the mode, brand and, since DW-09, the fleet's
 * latest app version. One query, one staleness rule everywhere.
 *
 * `fresh`: the screen asks again each time it opens (showing what it has
 * meanwhile), for a choice an administrator may have just changed, such as
 * the payment methods a top-up offers.
 */
export const useConfig = ({ fresh = false }: { fresh?: boolean } = {}) =>
  useGetConfig({
    query: { staleTime: STALE.reference, ...(fresh && { refetchOnMount: "always" as const }) },
  })

/**
 * The deployment's mode (LLD §6.4): `me.mode` once signed in, `config.mode`
 * before; undefined while neither has answered. Money is shown only when
 * this says "normal" (`isMoneyVisible`).
 */
export function useMode(): "normal" | "standalone" | undefined {
  const { data: me } = useMe()
  const { data: config } = useConfig()
  return me?.mode ?? config?.mode
}
